export const CHECKLIST_REFERENCES_CREATE = "CHECKLIST_REFERENCES_CREATE";
export const ACTUAL_STATE_IMAGES_SAVE = "ACTUAL_STATE_IMAGES_SAVE";
export const SET_SIGN_CHECKLIST_TRANSPORTIST =
  "SET_SIGN_CHECKLIST_TRANSPORTIST";
export const SET_SIGN_CHECKLIST_RECEPTOR = "SET_SIGN_CHECKLIST_RECEPTOR";
export const CHECKLIST_DATA_UPDATE = "CHECKLIST_DATA_UPDATE";
export const MAIN_CHECKLIST_ARRAY_GET = "MAIN_CHECKLIST_ARRAY_GET";
export const ACTUAL_STATE_IMAGES_GET = "ACTUAL_STATE_IMAGES_GET";
export const CHECKLIST_ITEM_DATA_GET = "CHECKLIST_ITEM_DATA_GET";
export const CHECKLIST_DATA_RESET = "CHECKLIST_DATA_RESET";
export const FUEL_ARRAY_GET = "FUEL_ARRAY_GET";
export const SAVE_STATUS_DETAIL = "SAVE_STATUS_DETAIL";
export const ODOO_CHECKLIST_URL_SAVE = "ODOO_CHECKLIST_URL_SAVE";
export const CHECKLIST_REFERENCE_TRANSFER = "CHECKLIST_REFERENCE_TRANSFER";
export const SET_ORDER_DATA = "SET_ORDER_DATA";
export const HOROMETRO_SET_DATA = "HOROMETRO_SET_DATA";
export const HOROMETRO_RESET_DATA = "HOROMETRO_RESET_DATA";
export const FUEL_ARRAY_RESET = "FUEL_ARRAY_RESET";
export const UPDATE_STATE_CHECKLIST = "UPDATE_STATE_CHECKLIST";
export const SET_CHECKLIST_DATA = "SET_CHECKLIST_DATA";
export const SET_BRANCH_DATA = "SET_BRANCH_DATA";
export const SET_EMAILS_NOTIFICATIONS = "SET_EMAILS_NOTIFICATIONS";
